(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elvore-product-disclosures"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('elvore-product-disclosures'))customElements.define('elvore-product-disclosures',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();const options={signal:this.abort.signal};this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-ev-guide]');this.trigger?.addEventListener('click',()=>{this.oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();},options);this.querySelector('[data-ev-close]')?.addEventListener('click',()=>this.dialog.close(),options);this.dialog?.addEventListener('close',()=>{document.body.style.overflow=this.oldOverflow||'';this.trigger?.focus();},options);this.dialog?.addEventListener('click',event=>{const b=this.dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)this.dialog.close();},options);}
disconnectedCallback(){if(this.dialog?.open){this.dialog.close();document.body.style.overflow=this.oldOverflow||'';}this.abort?.abort();}
});
  } catch(e) { console.error(e); }
})();

})();
